import { GenericModel } from "../../generic.model";
import {StationArrayModel} from "./stationArray.model";
import {makeModel} from "../../../service/utils/utils.service";

export class LocationArrayModel extends GenericModel {
    public stationArray: StationArrayModel[];
    public keyArray: string[];
    public xId: string;

    protected fromJson(json?: any): boolean {
        this.stationArray =  makeModel(json.stationArray, StationArrayModel);
        this.keyArray = json.keyArray ?? null;
        this.xId = json.xId ?? null;
        return this.isValid();
    }

    protected isValid(): boolean {
        return true;
    }
}